__webpack_require__.p = "/quintype-malibu/assets/";